import { ChatInitializationStoredConfig } from '../types'

export const getPreviousChannelConfig = () => {
  const chatPreviouslyInitialized = sessionStorage.getItem('chatInitialized')

  if (!chatPreviouslyInitialized) return undefined
  return JSON.parse(chatPreviouslyInitialized) as ChatInitializationStoredConfig
}
